"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { createStore } from "zustand/vanilla";
import { subscribeWithSelector } from "zustand/middleware";
import filterStore from "./filterStore";
import dropdownFilterStore from "./dropdownFilterStore";
import memoryStore from "./memoryStore";
import configStore from "./configStore";
const store = createStore(
  subscribeWithSelector((set, get) => ({
    /**
     * Filters given by the backend
     */
    defaultFilters: [],
    /**
     * data point that is currently clicked
     */
    selectedPoint: void 0,
    /**
     *
     */
    selectedScope: null,
    previousState: null,
    hasNoScopeSelected: () => {
      return !get().selectedScope || get().selectedScope === null;
    },
    /**
     * Action when we click on a point.
     */
    selectPoint: (point) => {
      const { saveState } = memoryStore.getState();
      saveState();
      set((state) => __spreadProps(__spreadValues({}, state), {
        selectedPoint: point,
        previousState: state
      }));
    },
    /**
     * Action when a scope is selected.
     * - select the scope if any
     * -
     */
    selectScope: (scope) => {
      const { saveState } = memoryStore.getState();
      saveState();
      dropdownFilterStore.setState(({ nextFilters, selectedFilters }) => ({
        nextFilters: __spreadProps(__spreadValues({}, nextFilters), { GeoScopeFilter: `${(scope == null ? void 0 : scope.id) || "all"}` }),
        selectedFilters: __spreadProps(__spreadValues({}, selectedFilters), { GeoScopeFilter: `${(scope == null ? void 0 : scope.id) || "all"}` })
      }));
      set((state) => {
        var _a;
        return __spreadProps(__spreadValues({
          selectedScope: scope || null
        }, `${scope == null ? void 0 : scope.id}` !== `${(_a = state.selectedScope) == null ? void 0 : _a.id}` ? { previousState: state } : null), {
          // unselect point when moving away from its scope
          selectedPoint: state.selectedPoint && state.selectedPoint.geoScopeId === (scope == null ? void 0 : scope.id) ? state.selectedPoint : null
        });
      });
      if (scope) scope.repaint();
    },
    /**
     * Go back to previous state
     */
    goBack: () => {
      set((state) => __spreadValues({}, state.previousState));
      const { popState } = memoryStore.getState();
      setTimeout(popState, 32);
    }
  }))
);
store.subscribe(
  (state) => [state.selectedScope],
  ([selectedScope]) => {
    dropdownFilterStore.getState().close();
    const { activeFilters, setFilters, scopeFilter, defaultFilters } = filterStore.getState();
    const filtersWithoutScopes = activeFilters.filter(({ scopeFilter: scopeFilter2 }) => {
      return !scopeFilter2;
    });
    const currentScopeFilterId = scopeFilter(activeFilters);
    if (`${currentScopeFilterId}` === `${selectedScope == null ? void 0 : selectedScope.id}`) return;
    if (selectedScope == null ? void 0 : selectedScope.id) {
      const matchFilter = activeFilters.find(
        ({ scopeFilter: scopeFilter2 }) => (scopeFilter2 == null ? void 0 : scopeFilter2.scopeId) === selectedScope.id
      );
      if (!matchFilter)
        setFilters(
          filtersWithoutScopes.concat({ scopeFilter: { scopeId: selectedScope.id } })
        );
    } else {
      const defaultScopeFilter = defaultFilters.find(({ scopeFiler }) => scopeFilter);
      if (defaultScopeFilter) setFilters(filtersWithoutScopes.concat(defaultScopeFilter));
      else setFilters(filtersWithoutScopes);
    }
  }
);
store.subscribe(
  (state) => [state.selectedScope],
  ([selectedScope], [previousScope]) => {
    if (previousScope) previousScope.repaint();
    if (selectedScope) {
      selectedScope.repaint();
    }
    dropdownFilterStore.getState().close();
  }
);
store.subscribe(
  (state) => [state.selectedPoint],
  (_0, _1) => __async(void 0, [_0, _1], function* ([selectedPoint], [previousPoint]) {
    if (!selectedPoint) {
      return;
    }
    dropdownFilterStore.getState().close();
    configStore.getState().openAside();
    selectedPoint.repaint();
    yield selectedPoint.panToMarker();
    if (previousPoint) previousPoint.repaint();
  })
);
export default store;
